import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDropdown from "../../../Common/ReactDropdown";

const CreateReceipe = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [product, setProduct] = useState([]);
  const [rmpm, setRmpm] = useState([]);
  const [error, setError] = useState({});
  const [lastReceiptNo, setLastReceiptNo] = useState("000001");
  const [list, setList] = useState([{ product_id: "", qty: "", desc: "" }]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      try {
        // const resProduct = await Http.get("/finished-good");
        const resProduct = await Http.get("/product-group-select2");
        setProduct(resProduct.data);

        const resRmpm = await Http.get("/raw-packing-materials");
        setRmpm(resRmpm.data);

        // const resLastReceiptNo = await Http.get("/last-receipe-no");
        // setLastReceiptNo(resLastReceiptNo.data);

        const resLastCodeIncrement = await Http.get(
          "/last-code-increment-by-one/receipes/receipt_no/R"
        );
        setLastReceiptNo(resLastCodeIncrement.data);

        getCurrentDateInput();
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  // Set Experience State
  const handleInputChange = (e, index) => {
    const { name, value } = e.target; // Chanages Experience Input Name and Value
    const inputInfo = [...list]; // Defined Experience State All Information into List Variable

    inputInfo[index][name] = value;
    setList(inputInfo);
  };

  const getCurrentDateInput = () => {
    const dateObj = new Date();

    // get the month in this format of 04, the same for months
    const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    const day = ("0" + dateObj.getDate()).slice(-2);
    const year = dateObj.getFullYear();

    const shortDate = `${year}-${month}-${day}`;

    setInputs((values) => ({ ...values, ["date"]: shortDate }));
  };
  // Default Load
  // const fetchData = () => {
  //   Http.get("/finished-good").then((res) => {
  //     setProduct(res.data);
  //   });
  //   Http.get("/raw-packing-materials").then((res) => {
  //     setRmpm(res.data);
  //   });
  //   // Http.get("/last-receipe-no").then((res) => {
  //   //   setLastReceiptNo(res.data);
  //   // });
  //   Http.get("/last-code-increment-by-one/receipes/receipt_no/R").then((res) => {
  //     setLastReceiptNo(res.data);
  //   });
  //   getCurrentDateInput();
  // };
  // useEffect(() => {
  //   fetchData();
  // }, []);
  // End Default Load

  // Add More List
  const addMoreList = () => {
    setList([...list, { product_id: "", qty: "", desc: "" }]); // Add One More List
  };
  // Remove List
  const removeList = (index) => {
    const inputInfo = [...list]; // Load All Existing experience State Data
    inputInfo.splice(index, 1); // Remove Experience by Index/Click Event Wise
    setList(inputInfo); // Replace Existing experience into State
  };

  const formSubmit = () => {
    const listArr = [];
    Object.keys(list).forEach((key) => {
      listArr.push(list[key]);
    });

    inputs.items = listArr;
    inputs.receipt_no = lastReceiptNo;
    Http.post("/receipe", inputs)
      .then((res) => {
        navigate("/receipe", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };
  const reactDropdownHandler = (field, prop) => (e) => {
    const selectedValue = e?.value ? e.value[prop] : "";
    setInputs((values) => ({
      ...values,
      [field]: selectedValue,
    }));
  };

  // Handler for list item dropdowns
  const listDropdownHandler = (index, field, prop) => (e) => {
    const inputInfo = [...list];
    inputInfo[index][field] = e?.value ? e.value[prop] : "";
    setList(inputInfo);
  };

  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Receipe</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Create Receipe Form</h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>
                      Date <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={inputs.date || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label>Receipt no</label>
                    <input
                      type="text"
                      className="form-control"
                      name="receipt_no"
                      value={lastReceiptNo || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label>
                      Batch Size <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="batch_size"
                      value={inputs.batch_size || ""}
                      onChange={handleChange}
                    />
                  </div>
                  
                  <div className="col-lg">
                    <label htmlFor="">
                      Finished Good <i className="fa fa-star required"></i>
                    </label>
                    <ReactDropdown
                      options={product}
                      optitle={"name"}
                      onChange={reactDropdownHandler("product_id", "id")}
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-10"></div>
                  <div className="col-2">
                    <button
                      className="btn btn-info btn-block mg-b-10"
                      onClick={addMoreList}
                    >
                      <i className="fa fa-plus mg-r-10"></i> ADD More
                    </button>
                  </div>
                  <div className="col-12">
                    <table className="table table-sm align-items-center mb-0">
                      <thead>
                        <tr>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Product
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Qty
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Description
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.from(list).map((x, i) => (
                          <tr key={i}>
                            <td>
                              <ReactDropdown
                                options={rmpm}
                                optitle={"name"}
                                onChange={listDropdownHandler(
                                  i,
                                  "product_id",
                                  "id"
                                )}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                name="qty"
                                value={x.qty || ""}
                                onChange={(e) => handleInputChange(e, i)}
                              />
                            </td>
                            <td>
                              <textarea
                                className="form-control"
                                name="desc"
                                value={x.desc || ""}
                                onChange={(e) => handleInputChange(e, i)}
                              ></textarea>
                            </td>
                            <td>
                              {list.length > 1 ? (
                                <button
                                  className="btn btn-danger btn-block"
                                  onClick={() => removeList(i)}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              ) : (
                                ""
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-6"></div>
                  <div className="col-3"></div>
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Create
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default CreateReceipe;
